import React, { Component } from 'react';

class TeamTotalsRow extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <tr>
                <td className="player">Totals:</td>
                <td></td>
                <td>{this.props.fgm}</td>
                <td>{this.props.fga}</td>
                <td>{this.props.fgp}</td>
                <td>{this.props.tpm}</td>
                <td>{this.props.tpa}</td>
                <td>{this.props.tpp}</td>
                <td>{this.props.ftm}</td>
                <td>{this.props.fta}</td>
                <td>{this.props.ftp}</td>
                <td>{this.props.offReb}</td>
                <td>{this.props.defReb}</td>
                <td>{this.props.totReb}</td>
                <td>{this.props.assists}</td>
                <td>{this.props.turnovers}</td>
                <td>{this.props.steals}</td>
                <td>{this.props.blocks}</td>
                <td>{this.props.pFouls}</td>
                <td>{this.props.points}</td>
                <td>{this.props.plusMinus}</td>
            </tr>
        );
    }
}

export default TeamTotalsRow;